module.exports = __webpack_public_path__ + "static/media/005-chat.6e960ae2.svg";